import { defineComponent as _defineComponent } from 'vue';
import { ref, computed, watch } from 'vue';
import SearchService from '@/services/SearchService.ts';
import { snackbar } from '@/store/snackbar';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BookingSelector',
    props: {
        value: { default: null },
        label: { default: 'Koppla till bokning (valfritt)' },
        outlined: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        autofocus: { type: Boolean, default: false },
        hideDetails: { type: Boolean, default: false },
        showCheckedInBookingsOption: { type: [Boolean, String], default: false },
        searchContext: { default: null },
        searchParam: { type: [String, Number, Boolean, null], default: null }
    },
    emits: ["input", "update:model-value"],
    setup(__props, { emit }) {
        const props = __props;
        const searchString = ref('');
        const searchResults = ref(null);
        const isLoading = ref(false);
        let currentRequestId = 0;
        const checkedInOnly = ref(false);
        if (props.showCheckedInBookingsOption === 'preselect') {
            checkedInOnly.value = true;
        }
        watch(() => (searchString.value ?? '').trim(), async (search) => {
            if (!search) {
                searchResults.value = null;
                isLoading.value = false;
                return;
            }
            const requestId = ++currentRequestId;
            isLoading.value = true;
            SearchService.searchBookings({
                searchString: search,
                checkedInBookingsOnly: checkedInOnly.value,
                searchContext: props.searchContext,
                searchParam: props.searchParam
            })
                .then(({ data }) => {
                if (requestId !== currentRequestId) {
                    return;
                }
                window.enrich.enrichBooking(data.data.bookings);
                searchResults.value = data.data.bookings;
            })
                .catch((err) => {
                if (requestId !== currentRequestId) {
                    return;
                }
                snackbar.error('Fel vid sökning efter bokningar: ' + err.message);
            })
                .finally(() => {
                if (requestId === currentRequestId) {
                    isLoading.value = false;
                }
            });
        });
        // Watch for external prop changes to clear search when value is cleared
        watch(() => props.value, (newVal) => {
            if (!newVal) {
                searchString.value = '';
            }
        });
        const handleInput = (value) => {
            emit('input', value);
            emit('update:model-value', value);
            searchString.value = '';
        };
        const selectorItems = computed(() => {
            const selectedBooking = props.value;
            const searchTerm = (searchString.value ?? '').trim();
            if (searchTerm === '') {
                return selectedBooking ? [selectedBooking] : [];
            }
            const foundBookings = searchResults.value ?? [];
            if (selectedBooking && !foundBookings.find(b => b.id === selectedBooking.id)) {
                return [selectedBooking, ...foundBookings];
            }
            return foundBookings;
        });
        return { __sfc: true, props, emit, searchString, searchResults, isLoading, currentRequestId, checkedInOnly, handleInput, selectorItems };
    }
});
